module.exports = __webpack_public_path__ + "static/media/ngoHeaderOverlayTab.a7895b24.svg";